<template>
  <section v-show="!!lastSaveDate">
    <loading-overlay :hidden="!loading"></loading-overlay>
    <p>{{ lastSaveDateString }}</p>
  </section>
</template>

<script>
import LoadingOverlay from './LoadingOverlay'
import { getPrettyTime, getPrettyDate } from '../utils/date'
import { getTime, startOfToday } from 'date-fns'

export default {
  name: 'lastSavepointIndicator',
  components: { LoadingOverlay },
  props: {
    lastSaveDate: Date,
    loading: Boolean,
  },
  computed: {
    lastSaveDateString() {
      if (!this.lastSaveDate) {
        return ''
      }

      let saveDateTime = getTime(this.lastSaveDate)
      let startOfTodaySeconds = getTime(new Date(startOfToday()))
      let dateSaveTimeDifference = (saveDateTime - startOfTodaySeconds) / 1000
      let dayDiff = Math.floor(dateSaveTimeDifference / 86400)

      switch (dayDiff) {
        case 0:
          return this.$t('question-answer.last-saved-time', {
            time: getPrettyTime(this.lastSaveDate),
          })
        case -1:
          return this.$t('question-answer.last-saved-yesterday')

        default:
          return this.$t('question-answer.last-saved-date', {
            date: getPrettyDate(this.lastSaveDate),
          })
      }
    },
  },
}
</script>

<style scoped></style>
